export const MIN_REST_SEC = 10;
export const MAX_REST_SEC = 600;
export const MAX_SETS_PER_EXERCISE = 20;
export const MAX_WEIGHT = 1000;
export const MAX_REPS = 200;
export const MAX_PROGRAM_LENGTH_DAYS = 14;
export const MAX_PERCENT_1RM = 150;
